<template>
  <div
    v-if="$store.state.adminOpen && $store.state.authUser.admin"
    style="
      position: fixed;
      inset: 0;
      z-index: 50;
      background: rgba(8, 9, 11, 0.72);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 32px;
    "
    @click.self="close()">
    <div
      style="
        width: 1080px;
        max-width: 100%;
        height: 84vh;
        display: flex;
        flex-direction: column;
        background: var(--back-content);
        border: 1px solid var(--border);
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
      ">
      <div header style="height: 52px; min-height: 52px; max-height: 52px; gap: 11px">
        <span style="font-size: 15px; font-weight: 700; color: #fff">Administration</span>
        <span class="mono" style="font-size: 10px; letter-spacing: 0.14em; color: var(--hsl-46)">{{ current.label.toUpperCase() }}</span>
        <v-btn icon small class="delbtn" style="margin-left: auto" @click="close()"><v-icon size="18">mdi-close</v-icon></v-btn>
      </div>

      <div style="flex: 1; display: flex; min-height: 0">
        <div
          style="
            width: 200px;
            flex: none;
            display: flex;
            flex-direction: column;
            gap: 7px;
            padding: 14px 12px;
            background: var(--back-root);
            border-right: 1px solid var(--border);
          ">
          <div class="micro" style="padding: 0 2px 2px">Sections</div>
          <div
            v-for="s in sections"
            :key="s.id"
            item
            horizontal
            align-center
            :selected="s.id === section"
            style="height: auto; padding: 9px 11px; font-size: 12.5px; font-weight: 600"
            @click="section = s.id">
            {{ s.label }}
          </div>
        </div>
        <div style="flex: 1; display: flex; flex-direction: column; min-width: 0; min-height: 0">
          <MetadataSetAdmin v-if="section === 'metadata'" />
          <UploadAdmin v-else-if="section === 'uploads'" />
          <WebhookAdmin v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MetadataSetAdmin from "@/views/components/MetadataSetAdmin.vue";
import UploadAdmin from "@/views/components/UploadAdmin.vue";
import WebhookAdmin from "@/views/components/WebhookAdmin.vue";

export default {
  components: { MetadataSetAdmin, UploadAdmin, WebhookAdmin },
  data() {
    return {
      section: "metadata",
      sections: [
        { id: "metadata", label: "Metadata Sets" },
        { id: "uploads", label: "Uploads" },
        { id: "webhooks", label: "Webhooks" },
      ],
    };
  },
  computed: {
    current() {
      return this.sections.find((s) => s.id === this.section);
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKey);
  },
  methods: {
    onKey(e) {
      if (e.key === "Escape") this.close();
    },
    close() {
      this.$store.state.adminOpen = false;
    },
  },
};
</script>
